/** @ts-expect-error */
import sanitizeHTML from "../sap/base/security/sanitizeHTML.js";
/** @ts-expect-error */
import URLListValidator from "../sap/base/security/URLListValidator.js";

export {
	URLListValidator,
	sanitizeHTML,
};
